import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import MatchupCard from '../MatchupCard';
import { DateUtils } from '../../utils';
import { useLang } from '../../hooks/config';

import { imgSizes } from './constants';

const Card = (props) => {

    const {
        index,
        gamePk,
        gameDate,
        awayTeamId,
        homeTeamId,
        onClick,
    } = props;

    const lang = useLang();

    const handleClick = useCallback((event) => {

        onClick(event, gamePk, index);

    }, [
        onClick,
        gamePk,
        index,
    ]);

    return (
        <MatchupCard
            as={Link}
            to={`/game/${gamePk}`}
            onClick={handleClick}
            imgSizes={imgSizes}
            awayTeamId={awayTeamId}
            homeTeamId={homeTeamId}
            date={gameDate ? DateUtils.formatDate(gameDate, lang) : ''}
        />
    );

};

Card.propTypes = {
    index: PropTypes.number.isRequired,
    gamePk: PropTypes.number,
    gameDate: PropTypes.string,
    awayTeamId: PropTypes.number,
    homeTeamId: PropTypes.number,
    onClick: PropTypes.func.isRequired,
};

Card.defaultProps = {
    gamePk: 0,
};

export default Card;
